import { typesetMathMl } from '../utils/mathml'

export default {
  mounted() {
    this.typesetMathMl()
  },
  updated() {
    this.typesetMathMl()
  },
  methods: {
    typesetMathMl() {
      typesetMathMl(this.$el)
    },
  },
}
